import dashboardEn from "./content/en/dashboard.md?raw";
import studiesEn from "./content/en/studies.md?raw";
import platformUsersEn from "./content/en/platform-users.md?raw";
import featuresEn from "./content/en/features.md?raw";
import emailTemplatesEn from "./content/en/email-templates.md?raw";
import artifactsInstrumentsEn from "./content/en/artifacts-instruments.md?raw";
import studyDashboardEn from "./content/en/study-dashboard.md?raw";
import studyDesignerEn from "./content/en/study-designer.md?raw";
import participantsEn from "./content/en/participants.md?raw";
import participantGroupsEn from "./content/en/participant-groups.md?raw";
import econsentEn from "./content/en/econsent.md?raw";
import medicationEn from "./content/en/medication.md?raw";
import screeningReasonsEn from "./content/en/screening-reasons.md?raw";
import informationSheetsEn from "./content/en/information-sheets.md?raw";
import todoEn from "./content/en/todo.md?raw";
import auditTrailEn from "./content/en/audit-trail.md?raw";
import exportEn from "./content/en/export.md?raw";
import studySettingsEn from "./content/en/study-settings.md?raw";
import studyUsersEn from "./content/en/study-users.md?raw";
import siteRightsEn from "./content/en/site-rights.md?raw";
import studyRightsEn from "./content/en/study-rights.md?raw";
import consentTrackerEn from "./content/en/consent-tracker.md?raw";
import queriesEn from "./content/en/queries.md?raw";
import appointmentsEn from "./content/en/appointments.md?raw";
import messagesEn from "./content/en/messages.md?raw";
import exerciseEn from "./content/en/exercise.md?raw";
import cmsLmsEn from "./content/en/cms-lms.md?raw";

import dashboardEs from "./content/es/dashboard.md?raw";
import studiesEs from "./content/es/studies.md?raw";
import platformUsersEs from "./content/es/platform-users.md?raw";
import featuresEs from "./content/es/features.md?raw";
import emailTemplatesEs from "./content/es/email-templates.md?raw";
import artifactsInstrumentsEs from "./content/es/artifacts-instruments.md?raw";
import studyDashboardEs from "./content/es/study-dashboard.md?raw";
import studyDesignerEs from "./content/es/study-designer.md?raw";
import participantsEs from "./content/es/participants.md?raw";
import participantGroupsEs from "./content/es/participant-groups.md?raw";
import econsentEs from "./content/es/econsent.md?raw";
import medicationEs from "./content/es/medication.md?raw";
import screeningReasonsEs from "./content/es/screening-reasons.md?raw";
import informationSheetsEs from "./content/es/information-sheets.md?raw";
import todoEs from "./content/es/todo.md?raw";
import auditTrailEs from "./content/es/audit-trail.md?raw";
import exportEs from "./content/es/export.md?raw";
import studySettingsEs from "./content/es/study-settings.md?raw";
import studyUsersEs from "./content/es/study-users.md?raw";
import siteRightsEs from "./content/es/site-rights.md?raw";
import studyRightsEs from "./content/es/study-rights.md?raw";
import consentTrackerEs from "./content/es/consent-tracker.md?raw";
import queriesEs from "./content/es/queries.md?raw";
import appointmentsEs from "./content/es/appointments.md?raw";
import messagesEs from "./content/es/messages.md?raw";
import exerciseEs from "./content/es/exercise.md?raw";
import cmsLmsEs from "./content/es/cms-lms.md?raw";

import { featuresMap } from "../../utils/features";
import { permissions, platformAdminPermissions } from "../../utils/roles";

export type HelpManualCategory = "platform" | "study";

/** Supported manual locales — mirrors src/i18n SUPPORTED_LANGUAGES (en/es only). */
export type HelpManualLocale = "en" | "es";

export const HELP_MANUAL_DEFAULT_LOCALE: HelpManualLocale = "en";

export type HelpManualSection = {
  id: string;
  category: HelpManualCategory;
  content: Record<HelpManualLocale, string>;
  /** Value from utils/features featuresMap — same flag StudySidebar checks to show/hide this screen's nav link. Topic is hidden when the current study has it disabled. */
  featureKey?: string;
  /** Study permission code from utils/roles — same check StudySidebar uses for this screen's nav link. */
  permissionKey?: string;
  /** Platform permission code — same check Sidebar uses for platform admin screens. */
  platformPermissionKey?: string;
};

export const HELP_MANUAL_CATEGORIES: Record<HelpManualCategory, string> = {
  platform: "USER_MANUAL_CATEGORY_PLATFORM",
  study: "USER_MANUAL_CATEGORY_STUDY",
};

export const HELP_MANUAL_SECTIONS: HelpManualSection[] = [
  // Platform Administration
  {
    id: "dashboard",
    category: "platform",
    content: { en: dashboardEn, es: dashboardEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },
  {
    id: "studies",
    category: "platform",
    content: { en: studiesEn, es: studiesEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },
  {
    id: "platform-users",
    category: "platform",
    content: { en: platformUsersEn, es: platformUsersEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },
  {
    id: "features",
    category: "platform",
    content: { en: featuresEn, es: featuresEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },
  {
    id: "email-templates",
    category: "platform",
    content: { en: emailTemplatesEn, es: emailTemplatesEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },
  {
    id: "artifacts-instruments",
    category: "platform",
    content: { en: artifactsInstrumentsEn, es: artifactsInstrumentsEs },
    platformPermissionKey: platformAdminPermissions.viewPlatform,
  },

  // Study Management
  {
    id: "study-dashboard",
    category: "study",
    content: { en: studyDashboardEn, es: studyDashboardEs },
    permissionKey: permissions.dashboardView,
  },
  {
    id: "study-designer",
    category: "study",
    content: { en: studyDesignerEn, es: studyDesignerEs },
  },
  {
    id: "participants",
    category: "study",
    content: { en: participantsEn, es: participantsEs },
    permissionKey: permissions.viewParticipant,
  },
  {
    id: "participant-groups",
    category: "study",
    content: { en: participantGroupsEn, es: participantGroupsEs },
    featureKey: featuresMap.participantGroups,
    permissionKey: permissions.viewParticipant,
  },
  {
    id: "econsent",
    category: "study",
    content: { en: econsentEn, es: econsentEs },
    featureKey: featuresMap.eConsent,
    permissionKey: permissions.econsentView,
  },
  {
    id: "consent-tracker",
    category: "study",
    content: { en: consentTrackerEn, es: consentTrackerEs },
    featureKey: featuresMap.eConsent,
    permissionKey: permissions.econsentTrackerView,
  },
  {
    id: "medication",
    category: "study",
    content: { en: medicationEn, es: medicationEs },
    featureKey: featuresMap.medication,
  },
  {
    id: "screening-reasons",
    category: "study",
    content: { en: screeningReasonsEn, es: screeningReasonsEs },
    permissionKey: permissions.studyDesigner,
  },
  {
    id: "information-sheets",
    category: "study",
    content: { en: informationSheetsEn, es: informationSheetsEs },
    permissionKey: permissions.informationSheetView,
  },
  {
    id: "todo",
    category: "study",
    content: { en: todoEn, es: todoEs },
    featureKey: featuresMap.todo,
    permissionKey: permissions.todoView,
  },
  {
    id: "audit-trail",
    category: "study",
    content: { en: auditTrailEn, es: auditTrailEs },
    permissionKey: permissions.auditLogs,
  },
  {
    id: "export",
    category: "study",
    content: { en: exportEn, es: exportEs },
    permissionKey: permissions.export,
  },
  {
    id: "study-settings",
    category: "study",
    content: { en: studySettingsEn, es: studySettingsEs },
    permissionKey: permissions.studySettings,
  },
  {
    id: "study-users",
    category: "study",
    content: { en: studyUsersEn, es: studyUsersEs },
    permissionKey: permissions.userManagement,
  },
  {
    id: "site-rights",
    category: "study",
    content: { en: siteRightsEn, es: siteRightsEs },
    permissionKey: permissions.userManagement,
  },
  {
    id: "study-rights",
    category: "study",
    content: { en: studyRightsEn, es: studyRightsEs },
    permissionKey: permissions.userManagement,
  },
  {
    id: "queries",
    category: "study",
    content: { en: queriesEn, es: queriesEs },
    featureKey: featuresMap.queries,
    permissionKey: permissions.viewParticipant,
  },
  {
    id: "appointments",
    category: "study",
    content: { en: appointmentsEn, es: appointmentsEs },
    featureKey: featuresMap.appointment,
  },
  {
    id: "messages",
    category: "study",
    content: { en: messagesEn, es: messagesEs },
    featureKey: featuresMap.messages,
  },
  {
    id: "exercise",
    category: "study",
    content: { en: exerciseEn, es: exerciseEs },
    featureKey: featuresMap.exercises,
  },
  {
    id: "cms-lms",
    category: "study",
    content: { en: cmsLmsEn, es: cmsLmsEs },
    featureKey: featuresMap.cms,
  },
];

export function getSectionContent(
  section: HelpManualSection,
  locale: string,
): string {
  return (
    section.content[locale as HelpManualLocale] ??
    section.content[HELP_MANUAL_DEFAULT_LOCALE]
  );
}

/** Section title is the file's own `# ` heading, so nav labels can never drift from the content. */
export function getSectionTitle(section: HelpManualSection, locale: string): string {
  const content = getSectionContent(section, locale);
  const match = content.match(/^#\s+(.+)$/m);
  return match ? match[1].trim() : section.id;
}
